"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicApiContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_openapi_1 = require("@anatine/zod-openapi");
const zod_1 = require("zod");
const c = (0, core_1.initContract)();
(0, zod_openapi_1.extendZodWithOpenApi)(zod_1.z);
exports.publicApiContract = c.router({
    oauthCallback: {
        method: "GET",
        path: "/oauth-callback",
        query: zod_1.z.object({
            code: zod_1.z.string(),
            state: zod_1.z.string(),
        }),
        responses: {
            200: c.otherResponse({
                contentType: "text/html",
                body: zod_1.z.string(),
            }),
        },
    },
    onBotEmailReceivedWebhook: {
        method: "POST",
        path: "/on-bot-email-received",
        contentType: "multipart/form-data",
        query: zod_1.z.object({
            key: zod_1.z.string(),
        }),
        body: zod_1.z.any(),
        responses: {
            200: zod_1.z.object({
                ok: zod_1.z.boolean(),
            }),
        },
    },
    onMeetingBaasWebhook: {
        method: "POST",
        path: "/on-meeting-baas-webhook",
        query: zod_1.z.object({
            key: zod_1.z.string(),
        }),
        body: zod_1.z.object({
            event: zod_1.z.string(),
            data: zod_1.z.object({
                bot_id: zod_1.z.string().uuid(),
                transcript: zod_1.z.array(zod_1.z.object({
                    speaker: zod_1.z.string(),
                    offset: zod_1.z.number(),
                    words: zod_1.z.array(zod_1.z.object({
                        start: zod_1.z.number(),
                        end: zod_1.z.number(),
                        word: zod_1.z.string(),
                    })),
                })),
                speakers: zod_1.z.array(zod_1.z.string()),
                mp4: zod_1.z.string().url(),
                event: zod_1.z.string().nullish(),
            }),
        }),
        responses: {
            200: zod_1.z.object({
                ok: zod_1.z.boolean(),
            }),
        },
    },
}, {
    pathPrefix: "/public",
});
